import { Sparkles, Droplets, Sofa, Ship, Bug } from "lucide-react";

const services = [
{
  id: "buffing",
  title: "Buffing & Polishing",
  description: "Has your boat lost its shine? Restore your boat's finish to showroom condition with our compound and polish services.",
  icon: Sparkles,
  image: "https://images.unsplash.com/photo-1741538985627-598bd37b8bae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxib2F0JTIwcG9saXNoaW5nfGVufDB8fHx8MTc3NTE4NTMzNnww&ixlib=rb-4.1.0&q=85"
},
{
  id: "waxing",
  title: "Waxing & Protection",
  description: "Long-lasting protective coatings that shield your vessel from UV rays, and environmental damage.",
  icon: Droplets,
  image: null
},
{
  id: "interior",
  title: "Interior Detailing",
  description: "Complete interior cleaning including upholstery, carpets, surfaces, and all cabin areas. We get every corner!",
  icon: Sofa,
  image: "https://images.pexels.com/photos/12059895/pexels-photo-12059895.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
},
{
  id: "exterior",
  title: "Exterior Wash",
  description: "Thorough hull and deck cleaning to remove grime and water stains from every surface.",
  icon: Ship,
  image: null
},
{
  id: "mold",
  title: "Mold & Mildew Removal",
  description: "Specialized treatment to eliminate mold, mildew, and odors, leaving your boat fresh and healthy.",
  icon: Bug,
  image: null
}];


export default function Services() {
  return (
    <section
      id="services"
      className="section-padding bg-[#F8FAFC]"
      data-testid="services-section">

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 lg:mb-16">
          <span
            className="inline-block text-xs tracking-[0.2em] uppercase font-bold text-[#64748B] mb-4"
            data-testid="services-label">

            What We Offer
          </span>
          <h2
            className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-[#0B1E36] tracking-tight"
            style={{ fontFamily: "'Outfit', sans-serif" }}
            data-testid="services-heading">

            Our Services
          </h2>
        </div>

        {/* Services Grid - Bento Style */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6">
          {services.map((service, index) => {
            const Icon = service.icon;
            const isLarge = index === 0 || index === 2;

            return (
              <div
                key={service.id}
                className={`service-card bg-white border border-[#E2E8F0] p-6 lg:p-8 ${
                isLarge ? "lg:row-span-1" : ""} ${
                service.image ? "relative overflow-hidden" : ""}`}
                data-testid={`service-card-${service.id}`}>

                {service.image &&
                <div
                  className="absolute inset-0 bg-cover bg-center opacity-10"
                  style={{ backgroundImage: `url(${service.image})` }} />

                }
                <div className="relative z-10">
                  <div className="w-12 h-12 bg-[#FACC15] flex items-center justify-center mb-6">
                    <Icon className="w-6 h-6 text-[#0B1E36]" />
                  </div>
                  <h3
                    className="text-xl sm:text-2xl font-medium text-[#0B1E36] mb-3"
                    style={{ fontFamily: "'Outfit', sans-serif" }}
                    data-testid={`service-title-${service.id}`}>

                    {service.title}
                  </h3>
                  <p
                    className="text-[#64748B] leading-relaxed"
                    data-testid={`service-desc-${service.id}`}>

                    {service.description}
                  </p>
                </div>
              </div>);

          })}
        </div>
      </div>
    </section>);

}